import { render, staticRenderFns } from "./Campanha.vue?vue&type=template&id=77311e6d&"
import script from "./Campanha.vue?vue&type=script&lang=js&"
export * from "./Campanha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports